import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useWixPriceUIContext } from "../WixPriceUIContext";
import { deleteWixPricing, fetchSingleWix, fetchWixDataPricing } from "../../../actions/wix-pricing/wix";

export function WixPriceDialog({ show, onHide, id }) {

  // Products UI Context
  const wixUIContext = useWixPriceUIContext();
  const wixUIProps = useMemo(() => {
    return {
      ids: id,
      queryParams: wixUIContext.queryParams,
      setQueryParams: wixUIContext.setQueryParams,
    };
  }, [wixUIContext, id]);

  // Products Redux state
  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();


  // if there weren't selected products we should close modal
  useEffect(() => {
    if (!wixUIProps.ids || wixUIProps.ids.length === 0) {
      onHide();
    } else {
      dispatch(fetchSingleWix(wixUIProps.ids));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, wixUIProps.ids]);

  const deleteWix = () => {
    // server request for deleting product by seleted ids
    enableLoading();
    dispatch(deleteWixPricing(id)).then(async (data) => {
      await dispatch(fetchWixDataPricing(wixUIProps.queryParams));
      onHide();
      disableLoading();

      await enqueueSnackbar('Wix pricing deleted successfully', {
        variant: "success",
        autoHideDuration: 4500,
      });
    });
  };

  const [loading, setLoading] = useState(false);

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby='example-modal-sizes-title-lg'>
      {loading}
      <Modal.Header closeButton>
        <Modal.Title id='example-modal-sizes-title-lg'>
          Wix Pricing Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!loading && (
          <span>Are you sure you want to remove wix pricing?</span>
        )}
        {loading && <span>Please wait, Wix pricing is deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type='button'
            onClick={onHide}
            className='btn btn-light btn-elevate'>
            Cancel
          </button>
          <> </>
          <button
            type='button'
            onClick={deleteWix}
            className='btn btn-primary btn-elevate'
            disabled={loading ? true : false}>
            Delete
            {loading && (
              <span className='ml-3 spinner px-2 spinner-white'></span>
            )}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
